import React from "react";

const HobbyCard = ({ hobby, index, delay }) => {
    // Format the index as 01, 02, etc.
    const formattedIndex = String(index + 1).padStart(2, '0');

    return (
        <div className={`reveal ${delay} group relative p-8 rounded-[2.5rem] bg-white dark:bg-surface-dark border border-gray-100 dark:border-gray-800 shadow-soft hover:shadow-hover transition-all duration-500 flex flex-col items-start text-left overflow-hidden min-h-[320px]`}>

            {/* Background Numbering - Decorative */}
            <span className="absolute top-6 right-8 text-5xl font-black text-gray-50 dark:text-gray-800/30 font-display select-none transition-colors duration-500 group-hover:text-primary/10">
                {formattedIndex}
            </span>

            {/* Icon: Floating Glass Circle */}
            <div className="size-14 rounded-2xl bg-gradient-to-br from-primary/20 to-primary/5 dark:from-primary/10 dark:to-transparent text-primary flex items-center justify-center mb-10 relative z-10 transition-all duration-500 group-hover:scale-110 group-hover:rotate-[-5deg] shadow-sm ring-1 ring-primary/20 group-hover:ring-primary group-hover:bg-primary group-hover:text-white">
                <span className="material-symbols-outlined text-3xl transition-transform duration-500 group-hover:scale-110">
                    {hobby.icon}
                </span>
            </div>

            {/* Content Wrapper */}
            <div className="relative z-10 flex flex-col flex-grow">
                <h3 className="text-2xl font-bold text-[#0d121b] dark:text-white font-display mb-4 tracking-tight flex items-center gap-3">
                    {hobby.title}
                    <span className="h-px w-0 bg-primary group-hover:w-8 transition-all duration-500"></span>
                </h3>

                <p className="text-gray-500 dark:text-gray-400 text-sm leading-relaxed font-medium">
                    {hobby.description}
                </p>
            </div>

            {/* Animated Corner Accent */}
            <div className="absolute top-0 right-0 w-24 h-24 bg-primary/5 rounded-bl-full translate-x-12 -translate-y-12 group-hover:translate-x-0 group-hover:translate-y-0 transition-transform duration-700 ease-out -z-0"></div>

            {/* Interaction Indicator: Bottom Right Arrow */}
            <div className="absolute bottom-6 right-8 opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
                <span className="material-symbols-outlined text-primary text-xl">
                    arrow_outward
                </span>
            </div>
        </div>
    );
};

export default HobbyCard;